import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PageWrapper } from '../components/layout/PageWrapper';
import { ScoreTable } from '../components/scoreboard/ScoreTable';
import { useSeasons, useSeason } from '../hooks/useScoreboard';
import { Seo } from '../components/Seo';

export function ArchivePage() {
  const { t } = useTranslation('scoreboard');
  const { data: seasons, isLoading } = useSeasons();
  const pastSeasons = seasons?.filter((s) => !s.isCurrent) ?? [];
  const [expanded, setExpanded] = useState<string | null>(null);
  const { data: scores } = useSeason(expanded ?? '');

  return (
    <PageWrapper>
      <Seo title="Архив сезонов" description="Архив результатов прошлых сезонов Queensland Mafia Club." path="/archive" />
      <h1 className="text-4xl font-bold text-white mb-8">{t('archive.title')}</h1>

      {isLoading ? (
        <div className="flex justify-center py-20">
          <div className="w-8 h-8 border-2 border-mafia-accent border-t-transparent rounded-full animate-spin" />
        </div>
      ) : pastSeasons.length === 0 ? (
        <p className="text-gray-400">{t('archive.empty')}</p>
      ) : (
        <div className="space-y-4">
          {pastSeasons.map((season) => (
            <div key={season.seasonId} className="bg-mafia-card border border-gray-800 rounded-2xl overflow-hidden">
              <button
                className="w-full flex items-center justify-between p-6 text-left hover:bg-white/5 transition-colors"
                onClick={() => setExpanded(expanded === season.seasonId ? null : season.seasonId)}
              >
                <div>
                  <h3 className="text-white font-semibold text-lg">{season.name}</h3>
                  <p className="text-gray-500 text-sm">
                    {season.startDate} — {season.endDate ?? '...'}
                  </p>
                </div>
                <span className="text-gray-400 text-xl">
                  {expanded === season.seasonId ? '▲' : '▼'}
                </span>
              </button>
              {expanded === season.seasonId && scores && (
                <div className="border-t border-gray-800">
                  <ScoreTable scores={scores} />
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </PageWrapper>
  );
}
